/**
 * package: com.inq.flash.client.chatskins
 * class: VideoPlayerScene7
 * @extends com.inq.flash.client.chatskins.VideoPlayerBase
 * @constructor
 */
com.inq.flash.client.chatskins.VideoPlayerScene7 = function () {
	com.inq.flash.client.chatskins.VideoPlayerBase.call(this);
	this.viewerConsN = "s7viewers";
	this.viewerName = "VideoViewer";
};
$hxClasses.extend(com.inq.flash.client.chatskins.VideoPlayerBase, com.inq.flash.client.chatskins.VideoPlayerScene7, "com.inq.flash.client.chatskins.VideoPlayerScene7");

com.inq.flash.client.chatskins.VideoPlayerScene7.prototype.setup = function (contObj, p) {
	var vidUrl = contObj.getStyle("vidSerUrl") || getParams(1), serUrl = contObj.getStyle("serUrl") || getParams(2),
		asset = contObj.getStyle("asset") || getParams(3), tw = window.top;
	if (vidUrl == null
		|| serUrl == null
		|| asset == null
		|| (!"s7viewers" in window && !"s7viewers" in tw)) {
		return;
	}
	contObj._div.innerHTML = "<div id='s7viewer' style='position:relative'>";
	var params = {
		"containerId": "s7viewer",
		"params": {
			"videoserverurl": vidUrl,
			"serverUrl": serUrl,
			"asset": asset,
			"autoplay": (getParams(4) && '1') || "0"
		}
	};
	if (this.isDivC()) {
		this.viewer = new tw.s7viewers.VideoViewer(params);
	} else
		this.viewer = new s7viewers.VideoViewer(params);
	this.container = contObj;
	this.name = asset;

	function getParams(index) {
		if (p && p.length > index) {
			return p[index]
		}
	}

};

/**
 * Registers handlers for events triggering by media player (viewer).
 */
com.inq.flash.client.chatskins.VideoPlayerScene7.prototype.registerEventH = function () {
	var that = this;
	this.viewer.setHandlers({
		"initComplete": function () {
			/**play should be started **/
		},
		/**
		 * Triggers each time an event occurs inside the viewer
		 * which may be handled by an event tracking system, such as Adobe Analytics.
		 * @see https://marketing.adobe.com/resources/help/en_US/s7/viewers_ref/c_html5_video_viewer_20_event_callbacks.html
		 * @param objID {String} not currently used.
		 * @param compClass {String} not currently used.
		 * @param instName {String} an instance name of the Viewer SDK component that triggered the event.
		 * @param timeStamp {Number} event time stamp.
		 * @param eventInfo {String} event payload.
		 */
		"trackEvent": function (objID, compClass, instName, timeStamp, eventInfo) {
			that.eHandler(eventInfo);
		}
	});

};

/**
 * Initializes the media player (viewer).
 */
com.inq.flash.client.chatskins.VideoPlayerScene7.prototype.initPlay = function () {
	/** player object initialized */
	if (!this.viewer) return;
	this.initialized();
	this.registerEventH();
	this.viewer.init();
};

/**
 * Handler of CLOSE event.
 * Can be called also by script command from agent and from the skin configuration.
 * @see: {@link com.inq.ui.Container.closeVideo}
 */
com.inq.flash.client.chatskins.VideoPlayerScene7.prototype.close = function() {
	this.clear();
	this.sendToAgent(com.inq.flash.client.chatskins.VideoPlayerBase.HIDDEN, "videoHidden");
};

/**
 * Attached on "close" button as listener of "click" event.
 * @see: {@link com.inq.ui.VideoPlayer#play}
 * @param {Event=} evt - DOM event, optional
 */
com.inq.flash.client.chatskins.VideoPlayerScene7.prototype.abandon = function(evt) {
	if (!this.isCompleted()) {
		this.sendToAgent(com.inq.flash.client.chatskins.VideoPlayerBase.CLOSE, "videoAbandoned");
	}
};

com.inq.flash.client.chatskins.VideoPlayerScene7.prototype.resume = function () {
	this.initPlay();
};

/**
 * Handles events triggered by media player (viewer).
 * @param {string} e - event info in string format divided by comma
 */
com.inq.flash.client.chatskins.VideoPlayerScene7.prototype.eHandler = function (e) {
	try {
		var vals = e.split(',');
		var meta = vals[vals.length - 1];
		switch (vals[0]) {
			case "LOAD":
				this.onLoad(meta);
				break;
			case "PAUSE":
				this.onPause();
				break;
			case "PLAY":
				this.onPlay(meta);
				break;
			case "METADATA":
				this.onMetadata(vals);
				break;
			case "STOP":
				this.onStop();
				break;
		}
	} catch (e) {

	}

};

/**
 * Cleans (resets) the current viewer instance.
 */
com.inq.flash.client.chatskins.VideoPlayerScene7.prototype.clear = function () {
	this.reset();
	if (this.container) {
		this.container._div.innerHTML = "";
	}
};

/**
 * Handler of LOAD event.
 * Sets the 'name' which used for messages.
 * @param {string} meta
 */
com.inq.flash.client.chatskins.VideoPlayerScene7.prototype.onLoad = function(meta) {
	if (this.isLoaded()) {
		// No need to handle onLoad twice if player is already in this state
		return;
	}
	this.name = meta;
	this.loaded();
	this.sendToAgent(com.inq.flash.client.chatskins.VideoPlayerBase.DISPLAY, "videoDisplayed");
};

/**
 * Handler of PAUSE event.
 * Notifies agent about pause of media if it was playing.
 */
com.inq.flash.client.chatskins.VideoPlayerScene7.prototype.onPause = function() {
	if (this.isPaused()) {
		// No need to handle onPause twice if player is already in this state
		return;
	}
	if (this.isPlaying()) {
		// Need to notify agent about pause only after start of media
		this.sendToAgent(com.inq.flash.client.chatskins.VideoPlayerBase.PAUSE, "videoPaused");
	}
	this.paused();
};

/**
 * Handler of PLAY event.
 * Notifies agent about playing the media.
 * @param {string} meta
 */
com.inq.flash.client.chatskins.VideoPlayerScene7.prototype.onPlay = function(meta) {
	if (this.isPlaying()) {
		// No need to handle onPlay twice if player is already in this state
		return;
	}
	/** @type {number} playback position in milliseconds */
	var position = parseInt(meta);
	if (isNaN(position) || position < 100) {
		this.sendToAgent(com.inq.flash.client.chatskins.VideoPlayerBase.PLAY + this.name + ".", "videoPlayed");
	} else {
		this.sendToAgent(com.inq.flash.client.chatskins.VideoPlayerBase.RESUME + "from " + position / 1000 + " S.", "videoResumed");
	}
	this.played();
};

/**
 * Handler of METADATA event.
 * Notifies agent about META event during of playback media.
 * @param {Array} eventInfo
 */
com.inq.flash.client.chatskins.VideoPlayerScene7.prototype.onMetadata = function(eventInfo) {
	/** @type {number} playback position in milliseconds */
	var position = parseInt(eventInfo[eventInfo.length - 1]);
	if (eventInfo[1] === "SEEK") {
		this.sendToAgent(com.inq.flash.client.chatskins.VideoPlayerBase.SEEK + "to " + position / 1000 + " S.", "videoSeeked");
	}
};

/**
 * Handler of STOP event.
 */
com.inq.flash.client.chatskins.VideoPlayerScene7.prototype.onStop = function() {
	this.completed();
};

